import { createFileRoute } from '@tanstack/react-router';
import { HomePage } from '@pages/home';

/**
 * Public Marketplace Route
 *
 * Route: /:locale/
 * The main landing page showing course catalog
 *
 * @updated DOC-0099 (2025-12-26) - Use HomePage from FSD pages layer
 */
export const Route = createFileRoute('/$locale/')({
  component: MarketplaceRoute,
});

function MarketplaceRoute() {
  const { locale } = Route.useParams();
  return <HomePage locale={locale} />;
}
